import { BooleanValueProperty } from './properties/boolean-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbTextareaWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Text Field';
    this.name = 'fb-textarea-composite';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any) {
    if (Array.isArray(props)) {
      const oldProperties = props;

      const labelProp = new TextProperty({ title: 'Header', value: '' });
      const contentProp = new TextProperty({
        title: 'Content',
        value: '',
      });
      const required = new BooleanValueProperty({ title: 'Required' });

      const optionsProp = props.map((item) => {
        return {
          required: new BooleanValueProperty(item.required || { title: 'Required' }),
          text: new TextProperty(item.text || { title: 'Question' }),
          placeholder: new TextProperty(item.placeholder),
          value: new TextProperty(item.value || { title: 'Default Text' }),
          rows: new TextProperty(item.rows || { title: 'Rows', value: '4' }),
          hint: new TextProperty(item.hint || { title: 'Hint' }),
        };
      });

      props = {
        text: labelProp,
        content: contentProp,
        required: required,
        columns: optionsProp,
      };
    }
    return props;
  }

  getProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({
        value: props.text ? props.text.value : 'Text Field 1',
      }),
      placeholder: new TextProperty({
        title: 'Placeholder',
        value: props.placeholder ? props.placeholder.value : 'Type here',
      }),
      value: new TextProperty(props.value || ''),
      columns: new TextProperty({
        title: 'Columns',
        value: props.columns ? +props.columns.value : 1,
      }),
      rows: new TextProperty(props.rows || ''),
    };
    return properties;
  }

  isValid() {
    if (!this.isRequired()) {
      return true;
    }

    return (
      this.properties.columns.filter((prop) => !prop.value.value || !prop.value.value.trim())
        .length === 0
    );
  }
}
